<template>
    <div class="overall-situation">
        <div class="registerList">
          <div class="topBox">
            <span class="topTitle">版权存证</span>
          </div>
            <div class="medium">
                <el-button size="medium" icon="el-icon-plus" @click="handleAdd">新建存证</el-button>
            </div>
            <!-- <div class="topBox topBoxBorder">
                <span class="topTitle">版权存证</span>
                <el-button class="topBtn" type="primary" @click="handleAdd">版权存证</el-button>
            </div> -->
            <el-row :gutter="20" class="filter">
                <el-col :span="5.5">
                    <label>作品名称：</label>
                    <el-input placeholder="请输入作品名称" v-model="listQuery.worksName" clearable @keyup.enter.native="getData"></el-input>
                </el-col>
                <el-col :span="5.5">
                    <label>审核状态：</label>
                    <el-select v-model="listQuery.examineStatus" placeholder="请选择" clearable @change="getData">
                        <el-option v-for="(item,index) in examineData" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-table :data="tableData"  v-loading="loadings">
                <el-table-column prop="worksName" label="作品名称" width="260">
                </el-table-column>
                <el-table-column prop="ownerName" label="存证持有人" width="260">
                </el-table-column>

                <el-table-column prop="worksType" label="作品类型" width="auto">
                    <template slot-scope="scope">
                        <template v-for="(item,index) in worksTypeData">
                        <span :key="index" v-if="scope.row.worksType == item.value">
                            {{item.label}}
                        </span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="examineStatus" label="审核状态" width="auto">
                    <template slot-scope="scope">
                        <template v-for="(item,index) in examineData">
                        <span :key="index" v-if="scope.row.examineStatus == item.value">
                            {{item.label}}
                        </span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="操作"  width="230">
                    <template slot-scope="scope">
                    <el-button type="text"  @click.native="handeleEdit(scope.row,2)">
                        详情
                    </el-button>
                    <el-button type="text"  v-if="scope.row.examineStatus==7" @click.native="handeleEdit(scope.row,1)">
                        编辑
                    </el-button>
                    <el-button type="text" v-if="scope.row.cerPath" @click.native="handeleEdit(scope.row,3)">
                        查看证书
                    </el-button>
                    <el-button type="text" v-if="scope.row.examineStatus==7" @click.native="handeCdelete(scope.row)">
                      删除
                    </el-button>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <el-dropdown>
                        <span class="el-dropdown-link">
                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-if="scope.row.examineStatus==1" @click.native="handeleEdit(scope.row,1)">
                            编辑
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="handeleEdit(scope.row,2)">
                            详情
                            </el-dropdown-item>
                            <el-dropdown-item v-if="scope.row.cerPath" @click.native="handeleEdit(scope.row,3)">
                            查看证书
                            </el-dropdown-item>
                        </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column> -->
            </el-table>
            <div class="paginationBox">
            <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="listQuery.pageSize" :page-sizes="[15, 30, 50, 100]" :total="total" @current-change="handleCurrentPage" @size-change="handlePageSize"></el-pagination>
            </div>
        </div>
    </div>
  </template>
  <script>
  import { getRlist, postCdelete } from "@/api/interface";
  export default {
    data() {
      return {
        // height: 'calc(100vh - 320px)',
        listQuery: {
          currentPage: 1,
          pageSize: 15,
          examineStatus: '',
          applicantUsn: '',
          worksName: ''
        },
        tableData: [],
        // fullscreenLoading: false,
        loadings: false,
        total: 0,
        examineData: [
          {
            label: '待审核',
            value: '1'
          },
          {
            label: '待复审',
            value: '2'
          },
          {
            label: '通过',
            value: '6'
          },
          {
            label: '不通过',
            value: '7'
          },
        ],
        worksTypeData: [
          {
            label: '文字',
            value: '1'
          },
          {
            label: '口述',
            value: '2'
          },
          {
            label: '音乐',
            value: '3'
          },
          {
            label: '戏剧',
            value: '4'
          },
          {
            label: '曲艺',
            value: '5'
          },
          {
            label: '舞蹈',
            value: '6'
          },
          {
            label: '杂技',
            value: '7'
          },
          {
            label: '美术',
            value: '8'
          },
          {
            label: '建筑',
            value: '9'
          },
          {
            label: '摄影',
            value: '10'
          },
          {
            label: '电影',
            value: '11'
          },
          {
            label: '类似摄制电影方法创作',
            value: '12'
          },
          {
            label: '工程设计图、产品设计图',
            value: '13'
          },
          {
            label: '地图、示意图',
            value: '15'
          },
          {
            label: '模型',
            value: '17'
          },
          {
            label: '录音制品',
            value: '19'
          },
          {
            label: '录像制品',
            value: '20'
          },
          {
            label: '其他作品',
            value: '181'
          },

        ],

      };
    },
    created() {
      this.listQuery.applicantUsn = this.$store.state.userData.usn
      // this.query.usn = this.$store.state.userData.usn
      // this.userData = this.$store.state.userData;
      if(this.listQuery.applicantUsn){
        this.getData();
      }else{
        this.$router.push({
            path: "/login"
          });
      }
      this.listQuery.applicantUsn = this.$store.state.userData.usn
      this.query.usn = this.$store.state.userData.usn
    },
    // created() {
    //   this.listQuery.applicantUsn = this.$store.state.userData.usn
    //   this.query.usn = this.$store.state.userData.usn
    //   this.userData = this.$store.state.userData;
    //   this.batchNo = this.$route.query.batchNo || ''
    //   if(this.userData.usn){
    //     this.getData();
    //     console.log("111",)
    //   }else{
    //     this.$router.push({
    //         path: "/login"
    //       });
    //       console.log("111222",)
    //   }
    //   // if(this.userData.usn){
    //   //   this.getData();
    //   // }else{
    //   //   this.$router.push({
    //   //       path: "/login"
    //   //     });
    //   // }
    //   // this.getData();
    // },
    methods: {
      handleAdd() {
        const userData = this.$store.state.userData
        if (userData.identityAuthentication != '2') {
          this.$message({
            message: '请先实名认证',
            type: 'warning'
          })
          this.$router.push({
          path: "/myAccount/userInfo/1"
        });
        window.sessionStorage.setItem("path", '/myAccount/userInfo/1');
          return
        }
        if(this.listQuery.applicantUsn){
          this.$router.push({
            path: "/certificate",
          });
        }else{
          this.$router.push({
            path: "/login"
          });
        }
      },
      getData() {
        this.loadings = true;
        // this.$axiosGet(
        //   this.$store.state.copyrightApi_url + "storage/evidence/my/list",
        //   this.listQuery
        // )
        getRlist(this.listQuery).then((res) => {
          this.loadings = false;
          if (res.code == 200) {
            this.tableData = res.data.list;
            this.total = res.data.page.totalRows;
          }
        });
      },
      handeleEdit(row, type) {

        if (type == 3) {
          window.open(this.$store.state.file_url+row.cerPath,'_blank')
        } else {
          // let str = row.worksPath.slice(row.worksPath.lastIndexOf("/") + 1);
          let str = row.worksPath

          this.$router.push({
            path: "/certificate",
            query: {
              id: row.id,
              ownerUsn: row.ownerUsn,
              ownerName: row.ownerName,
              worksName: row.worksName,
              worksType: row.worksType,
              worksFile: str,
              type: type
            },
          });
        }

      },
      handeCdelete( row ) {
        postCdelete({id:row.id}).then((res) =>{
          this.loadings = false;
          if (res.code == 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getData()
          }
        })
      },
      handleCurrentPage(val) {
        this.listQuery.currentPage = val;
        this.getData();
      },
      handlePageSize(val) {
        this.listQuery.pageSize = val;
        this.getData();
      },
    },
  };
  </script>
  <style scoped lang="scss">
  .overall-situation{
  // margin-top: 20px;
  padding-bottom: 50px;
  padding-top: 20px;
  // background: #F7F8FA;
  // min-height: 920px;
  // max-height: 1024px;
  .situation{
    margin: 0 auto;
    min-width: 1200px;
    max-width: 1200px;
    // min-height: 765px;
    // height: 3825px;
    padding: 20px 20px 20px 20px;
    background: #FFFFFF;
    opacity: 1;
    .Group{
      display: flex;
      span{
        margin-left: 10px;
        // width: 96px;
        // height: 24px;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        // line-height: 24px;
      }
    }
  }
  .statesBox {
        display: flex;
        justify-content: center;

    div {
        width: 60px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .states {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 8px;
        float: left;
    }

    .statesAdopt {
        //状态-通过
        background: #2DA55D;
    }

    .statesFail {
        //状态-不通过
        background: #E05F42;
    }

    .statesSubmit {
        //状态-待提交
        background: #954EFF;
    }

    .statesReviewed {
        //状态-待审核
        background: #4E77FF;
    }
    .statesConduct{
        //状态-待审核
        background: #FFC300;
    }
}

}
  .filter {
    margin: 10px 0;
    .el-input {
      width: 200px;
    }
  }
  .paginationBox {
    padding-top: 20px;
    overflow: hidden;
    .el-pagination {
      float: right;
    }
  }
  ::v-deep.el-dialog__footer {
    text-align: center;
    padding-bottom: 47px;
  }
.medium{
    text-align: right;
    font-size: 12px;
}
::v-deep .el-icon-plus{
  position: relative;
  top: -10px;
  color: #FFFFFF;
  margin-right: 5px;
  margin-left: -5px;
}
::v-deep .medium .el-button--medium{
    width: 102px !important;
    height: 31px !important;
    background: #1C77FF !important;
    border: 1px solid #1C77FF !important;
    opacity: 1;
    span{
      position: relative;
      top: -10px;
      left: 0px;
      font-size: 12px;
      margin: 0 auto;
      color: #FFFFFF;
      text-align: center;
      line-height: 28px;
      img{
        width: 12px;
        height: 12px;
        // margin-top: 1px;
      }
    }
  }
  .registerList{
  margin: 0 auto;
  margin-top: 20px;
  min-width: 1200px;
  max-width: 1200px;
  padding-top: 57px;
  padding: 20px;
  background: #FFFFFF;
  .topBox{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    line-height: 24px;
    margin-bottom: 33px;
    padding-left: 26px;
    background: url('../../../../assets/icon.png') no-repeat left center;
    background-size: 20px 20px;
  }
  .medium{
    text-align: right;
    font-size: 12px;
    margin-bottom: 20px;
  }
}
  </style>
